<template>
    <div>
        <v-subheader>{{ $t('settings.currency.title') }}</v-subheader>
        <v-container fluid grid-list-xl>
            <v-layout row justify-space-between>
            <v-flex xs6>
                <v-row v-for="(currency, index) in currencies" :key="index" justify-start>
                    <v-text-field
                        type="text"
                        v-model="currency.updated_at"
                        :label="$t('settings.currency.updated_at')"
                        disabled
                        >
                    </v-text-field>
                    <v-text-field
                        type="text"
                        v-model="currency.rate"
                        :label="currency.code">
                    </v-text-field>

                    <v-progress-circular
                        v-if="updating"
                        color="secondary"
                        indeterminate
                    ></v-progress-circular>

                    <v-btn
                        style="color: #fff"
                        :disabled="updating"
                        color="light-green"
                        @click="update(currency)"
                        >{{ $t("base.update") }}</v-btn
                    >
                </v-row>
            </v-flex>
            <v-flex xs2>

            </v-flex>

            </v-layout>
        </v-container>




    </div>
</template>

<script>
    export default {
        name: "Currency",
        data() {
            return {
                updating: false,
                currencies: []
            }
        },
        methods: {
            update(event) {
                this.updating = true
                this.$http.patch('/currency/' + event.id, {rate: event.rate })
                    .then(() => {

                        this.updating = false
                    })
                    .catch(() => {
                        this.updating = false
                    })
            }
        },
        mounted() {
            this.$http.get('/currency/settings')
                    .then((response) => {
                        this.currencies = response.data
                        this.updating = false
                    })
                    .catch(() => {
                        this.updating = false
                    })
        },
    }
</script>

<style scoped>

</style>
